/**
 * Created by pzf on 2018/12/26
 *
 */
import LayoutModal from './LayoutModal';

export default LayoutModal;